<script>
    export let featureData;
    export let feat;

    import tippy from "sveltejs-tippy";

    function clearFeature(feat) {
        featureData[feat] = featureData[feat].map((item) => false);
        featureData = featureData;
    }

    function fillFeature(feat) {
        featureData[feat] = featureData[feat].map((item) => true);
        featureData = featureData;
    }

    let empty = true;
    let full = false;

    $: full = featureData[feat[0]].every(x => x);
    $: empty = featureData[feat[0]].every(x => x == false);

</script>

<style>
    .track {
        display: grid;
        grid-template-columns: 4fr repeat(10, 1fr);
        align-items: center;
        margin-top: -0.15rem; /* to overlap row above */
    }
    .row-label {
        display: inline-block;
        text-align: right;
        text-transform: uppercase;
        margin-right: 1rem;
        font-size: 0.8rem;
        cursor: pointer;
    }
    input[type="checkbox"] {
        background-color: #eee;
        appearance: none;
        -webkit-appearance: none;
        vertical-align: -0.4rem;
        border: 0.15rem white solid;
        height: 2.5rem;
        margin: 0;
        border-radius: 0.75rem;
        width: calc(100% + 0.075rem); /* to slightly overlap neighbor to right */
    }
    input[type="checkbox"]:checked { background-color: #e24; }

    .lil-button {
        position: relative;
    	background-size: 100%;
	    background-origin: border-box;
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        border: 0.15rem white solid;
        margin: 0.25rem;
        cursor: pointer;
    }

    .lil-button:after { /* make the clickable area bigger */
        content: "";
        position: absolute;
        width: 2em;
        height: 2em;
        left: -0.5em;
        top: -0.5em;
    }


    .x {
        background-image: url(assets/svg/_x-small-red.svg);
    }

    .x.inactive {
        background-image: url(assets/svg/_x-small-grey.svg);
        cursor: default;
    }

    .all {
        background-image: url(assets/svg/_all-small-red.svg);
    }

    .all.inactive {
        background-image: url(assets/svg/_all-small-grey.svg);
        cursor: default;
    }
</style>

<div class="track">
    <span class="row-label" use:tippy={{content: feat[2]}}>{feat[1]}</span>
    {#each featureData[feat[0]] as val, i}
        <input type="checkbox" bind:checked={featureData[feat[0]][i]}/>
    {/each}
    <div style="display: flex; justify-content: flex-end; align-items: center;">
        <button class="lil-button hovery x" title="Clear row" disabled={empty} class:inactive={empty}
            use:tippy="{{content: 'Clear all timesteps for this feature'}}"
            on:click={clearFeature(feat[0])}>
            &nbsp;
        </button>
    </div>
    <div style="display: flex; justify-content: flex-start; align-items: center;">
        <button class="lil-button hovery all" title="Fill row" disabled={full} class:inactive={full}
            use:tippy="{{content: 'Fill all timesteps for this feature'}}"
            on:click={fillFeature(feat[0])}>
            &nbsp;
        </button>
    </div>
</div>

